import React, { Fragment, useEffect, useState } from 'react';

import 'devextreme-react/autocomplete';
import 'devextreme-react/date-range-box'; 

import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Button, SelectBox, TextBox } from 'devextreme-react';
import { BASE_API } from '../../../../../constants/api';
import { useAuth } from '../../../auth-provider/auth-provider';
import { errorNotify } from '../../../../../shared/notifications';
import { mobileNumberValidation } from '../../../../../shared/dataValidation';
import { makeArrayUnique, removeEmptyMembersFromArray } from '../../../../../shared/array-functions';
import { persianLanguage } from '../../../../../constants/persianTerms';
import { iranianMobileRegex } from '../../../../../shared/regex-patterns';
import SpinnerLoading from '../../../../components/spinner-loading/SpinnerLoading';
import OTPLogin from '../../otp-login/otp-login';
import { generalErrorMessage } from '../../../../errors/general-errors/general-errors';
import { convertPersianOrArabicNumbersToEnglishInTheString } from '../../../../../shared/numbers';


export default function MobileNumberForm(props){
  
    const otpUrlApi = `${BASE_API}otp/`;
    const auth = useAuth();
    const navigate = useNavigate()
    
    const [mobileNumbers, setMobileNumbers] = useState(JSON.parse(localStorage.getItem('mobileNumbers')) || []);
    const [mobileNumber, setMobileNumber] = useState(null);
    const [popupVisible, setPopupVisible] = useState(false)
    const [mobile, setMobile] = useState("");

    const [errorMessage, setErrorMessage] = useState(null);
    const [isDisabled, setIsDisabled] = useState(false);        
    const [uniqueArray, setUniqueArray] = useState(null);
    const [loginType, setLoginType] = useState(props?.loginType);
    
    // 🔥 NEW: Add state to track validation status
    const [isMobileValid, setIsMobileValid] = useState(false);
    const [validationError, setValidationError] = useState(null);
    
    useEffect(() => {
      if(auth?.token){
        navigate('/');
      }
      setLoginType(props?.loginType);
      if(mobileNumbers && mobileNumbers.length > 0){
        setMobileNumber(mobileNumbers[0])
      } else {
      }
     },[auth?.token]);

     function enableIsDisabled(){
      setTimeout(function(){ 
          setIsDisabled(false); 
      }, 2000);
    }

    // 🔥 NEW: Validate mobile number function
    const validateMobileNumber = (number) => {
      if (!number) {
        setValidationError('شماره موبایل الزامی است');
        setIsMobileValid(false);
        return false;
      }
      
      const cleaned = number.replace(/[^\d]/g, '');
      
      // Check against the regex pattern
      const regex = new RegExp(iranianMobileRegex);
      if (!regex.test(cleaned)) {
        setValidationError(persianLanguage.phrase.error.ERROR_MOBILE_NUMBER_WRONG_FORMAT);
        setIsMobileValid(false);
        return false;
      }
      
      setValidationError(null);
      setIsMobileValid(true);
      return true;
    };

  const handleSubmit =(e) => {
      // e.preventDefault(); // 🔥 IMPORTANT: Prevent default form submission
      
      // 🔥 FIX: Validate mobile number BEFORE anything else
      if (!mobileNumber) {
        setErrorMessage('لطفاً شماره موبایل خود را وارد کنید');
        return;
      }
      
      // 🔥 FIX: Double-check validation before proceeding
      if (!validateMobileNumber(mobileNumber)) {
        setErrorMessage(validationError || 'شماره موبایل نامعتبر است');
        return; // 🔥 STOP - Prevent OTP request
      }
      
      setIsDisabled(true);
      
      // Store mobile numbers in localStorage
      if (uniqueArray && uniqueArray.length > 0){
        setMobileNumbers(uniqueArray);
      }

      if('mobileNumbers' in localStorage){
        localStorage.removeItem('mobileNumbers');
      }
      localStorage.setItem('mobileNumbers', JSON.stringify(mobileNumbers));
      
      // 🔥 FIX: Only proceed with OTP if validation passes
      mobileNumberForOTPAction();
  };
    
    const mobileNumberForOTPAction = () => {
      // 🔥 FIX: Additional check before making API call
      if (!mobileNumber || !validateMobileNumber(mobileNumber)) {
        setErrorMessage('شماره موبایل نامعتبر است');
        setIsDisabled(false);
        return;
      }
      
      const formData =  {
        "mobileNumber": mobileNumber,
        "loginType": props?.loginType.type,
        "id": props?.authChallengeResult.id,
      }
      // console.log('formdata: ', formData)
      if(formData.mobileNumber){
        axios.post(otpUrlApi, formData).then(
          (response) => {
            setPopupVisible(true);
            setMobile(mobileNumber);
            setErrorMessage(null);
            setIsDisabled(false); // Reset disabled state
          }
      ).catch(
          (error) => {
              enableIsDisabled();
              if(error.response){
                // console.log('error.response is: ',error?.response?.data)
                if(error?.response?.data && typeof error?.response?.data === "string"){
                  setErrorMessage(error?.response?.data);
                } else if (error?.response?.data["error"] && typeof error?.response?.data["error"] === "string" && error?.response?.data["error"] === "mismatch challenge"){
                  window.location.reload()
                }else if (error?.response?.data["error"] && typeof error?.response?.data["error"] === "string" && error?.response?.data["error"] !== "mismatch challenge"){
                  setErrorMessage(error?.response?.data["error"]);
                }
                else if(error.response.status === 401 || error.response.status === 412 ||  error.response.status === 406){
                  setErrorMessage('اطلاعات ارسال شده نادرست است.');
                } else if(error.response.status === 406){


                } else if (error.response.status === 403) {
                  setErrorMessage(persianLanguage.phrase.error.ERROR_403);
                } else {
                  const message = generalErrorMessage(error.response.status)
                  setErrorMessage
                  (message);
                }
              }
          }
      );
      }
  }

  const popupToParent = (value) => {
    setPopupVisible(value);
    setMobileNumber(mobileNumber);
    setIsDisabled(false);
  }

  const mobileToParent = (value) => {
    setPopupVisible(value);
    setMobileNumber(null);
  }
    
  const handleMobileNumberChange = (e) => {
    // 🔥 FIX: Clear previous errors when user types
    setErrorMessage(null);
    setValidationError(null);
    
    if(e.event.target.value){
      const convertedNumber = convertPersianOrArabicNumbersToEnglishInTheString(e.event.target.value)
      const result = mobileNumberValidation(convertedNumber);

      if (result['status'] === 200){
        setMobileNumber(result["value"]);
        // 🔥 Validate as user types
        validateMobileNumber(result["value"]);

        let mobileNumberArray = mobileNumbers;
        mobileNumberArray.push(result['value'])
        if (mobileNumberArray.length > 0){
          let filteredArray = removeEmptyMembersFromArray(mobileNumberArray)
          const tempUniqueArray = makeArrayUnique(filteredArray);
          setUniqueArray(tempUniqueArray)
        }
      } else {
        // 🔥 FIX: Handle invalid input
        setIsMobileValid(false);
        setValidationError('شماره موبایل نامعتبر است');
      }
    } else {
      setIsMobileValid(false);
    }    
  }

  const handleMobileItemSelection = (e) => {
    // 🔥 FIX: Clear errors on selection
    setErrorMessage(null);
    setValidationError(null);
    
    if(e?.itemData){
      const result = mobileNumberValidation(e.itemData);
      if (result['status'] === 200){
        setMobileNumber(result["value"]);
        validateMobileNumber(result["value"]);
      } else {
        setIsMobileValid(false);
        setValidationError('شماره موبایل نامعتبر است');
      }
    }    
  }

  return (
    <Fragment>

    <div className="grid md:grid-cols-1 sm:grid-cols-12">
      <div className="sm:col-span-10">
      <div className="flex items-center justify-center ">
      <form action='login' 
        className="w-full max-w-md mx-auto p-4 sm:p-6 bg-white rounded-xl border border-gray-200 shadow-sm"
        onSubmit={handleSubmit}>

        {/* <div className='text-center' >{persianLanguage.word.general.ENTER}</div> */}
        {mobileNumbers.length > 0 &&
          <SelectBox
          name='mobileNumber'
          items={mobileNumbers}
          label={`${persianLanguage.word.user.MOBILE_NUMBER}`}
          labelMode='floating'
          acceptCustomValue={true}
          maxLength={11}
          defaultValue={mobileNumber}
          onItemClick={handleMobileItemSelection}
          onKeyUp={handleMobileNumberChange}
          onChange={(e) => {
            // 🔥 FIX: Validate on change as well
            if (e.value) {
              const converted = convertPersianOrArabicNumbersToEnglishInTheString(e.value);
              validateMobileNumber(converted);
            }
          }}
          >
            {/* <Validator>
              <PatternRule 
                pattern={iranianMobileRegex}
                message={persianLanguage.phrase.error.ERROR_MOBILE_NUMBER_WRONG_FORMAT}
              >
              </PatternRule>
            </Validator> */}
          </SelectBox>
        }
        {mobileNumbers.length === 0 &&
          <TextBox
          name='mobileNumber'
          label={`${persianLanguage.word.user.MOBILE_NUMBER}`}
          labelMode='floating'
          placeholder={`${persianLanguage.word.user.MOBILE_NUMBER}`}
          valueChangeEvent="keyup"
          onKeyUp={handleMobileNumberChange}
          onChange={(e) => {
            // 🔥 FIX: Validate on change
            if (e.value) {
              const converted = convertPersianOrArabicNumbersToEnglishInTheString(e.value);
              validateMobileNumber(converted);
            }
          }}
          >
            {/* <Validator>
              <PatternRule 
                pattern={iranianMobileRegex}
                message={persianLanguage.phrase.error.ERROR_MOBILE_NUMBER_WRONG_FORMAT}
              >
              </PatternRule>
            </Validator> */}
          </TextBox>
        }

        {/* 🔥 NEW: Show validation error message */}
        {validationError && (
          <div className="text-red-600 text-sm mt-1">
            {validationError}
          </div>
        )}

        <div>
          <Button        
            disabled={isDisabled || !isMobileValid} // 🔥 FIX: Disable button if mobile is invalid
            width='100%'
            id='mobileSubmitId'
            className='flex justify-content golden-button mt-5'
            onClick={handleSubmit}       
          >
            <div>
              {persianLanguage.phrase.general.GET_OTP_CODE}
              <SpinnerLoading isSpinning={isDisabled} />
            </div>
          </Button>
        </div>
        <div className='mt-1'>
            {errorMessage && <span className=' text-red-700 px-2 mt-5 rounded'>{errorMessage}</span>}
        </div>

      </form>                
      </div>
      </div>
      <div className="md:col-span-1 sm:col-span-1"></div>
    </div>
    {popupVisible
    && loginType
    && loginType.type === 'otp'
    &&
      <OTPLogin
      popupValue={popupVisible}
      mobile={mobile}
      popupToParent={popupToParent}
      mobileToParent={mobileToParent}
      authChallengeResult={props?.authChallengeResult}
      />
    }
    </Fragment>
  );    
  
}